import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SessionServiceInterface, SessionServiceStateType } from '@central-products/interface-session-service';
import { StateType as SessionManagerStateType } from '@central-products/interface-session-manager';
import { HTTPError } from './libs';
export var SessionService = /*#__PURE__*/function (_SessionServiceInterf) {
  _inherits(SessionService, _SessionServiceInterf);

  var _super = _createSuper(SessionService);

  function SessionService(config, dependencies) {
    var _this;

    _classCallCheck(this, SessionService);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", SessionServiceStateType.SESSION_UNKNOWN);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "abortController", void 0);

    _defineProperty(_assertThisInitialized(_this), "processSessionManagerState", function (_ref) {
      var state = _ref.state;

      if (state === SessionManagerStateType.LOGGED_IN) {
        _this.logIn();
      }

      if (state === SessionManagerStateType.NOT_LOGGED_IN) {
        _this.logOut();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setState", function (state) {
      if (_this.state === state) {
        return;
      }

      _this.state = state;

      if (_this.onStateChangedCallback) {
        _this.onStateChangedCallback({
          state: state
        });
      }
    });

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(SessionService, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var sessionManagerState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.dependencies['session-manager'].getState();

              case 2:
                sessionManagerState = _context.sent;
                this.dependencies['session-manager'].onStateChanged(this.processSessionManagerState);
                this.processSessionManagerState(sessionManagerState);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "logIn",
    value: function () {
      var _logIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state !== SessionServiceStateType.SESSION_UNKNOWN && this.state !== SessionServiceStateType.NO_SESSION)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.prev = 2;
                this.setState(SessionServiceStateType.SESSION_REQUESTED);
                _context3.next = 6;
                return this.initSession();

              case 6:
                this.setState(SessionServiceStateType.SESSION_EXISTS);
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                this.setState(SessionServiceStateType.NO_SESSION);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 9]]);
      }));

      function logIn() {
        return _logIn.apply(this, arguments);
      }

      return logIn;
    }()
  }, {
    key: "logOut",
    value: function () {
      var _logOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var previousState;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.state === SessionServiceStateType.NO_SESSION)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (!(this.state === SessionServiceStateType.SESSION_UNKNOWN)) {
                  _context4.next = 5;
                  break;
                }

                this.setState(SessionServiceStateType.NO_SESSION);
                return _context4.abrupt("return");

              case 5:
                if (this.state === SessionServiceStateType.SESSION_REQUESTED) {
                  if (this.abortController) {
                    this.abortController.abort();
                    this.abortController = undefined;
                  }
                }

                previousState = this.state;
                _context4.prev = 7;
                _context4.next = 10;
                return this.destroySession();

              case 10:
                this.setState(SessionServiceStateType.NO_SESSION);
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](7);
                this.setState(previousState);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[7, 13]]);
      }));

      function logOut() {
        return _logOut.apply(this, arguments);
      }

      return logOut;
    }()
  }, {
    key: "initSession",
    value: function () {
      var _initSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$this$dependenc, sessionToken, response;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.dependencies['session-manager'].getSessionToken({
                  serviceUrl: "".concat(this.config.sessionServiceUrl, "/handle")
                });

              case 2:
                _yield$this$dependenc = _context5.sent;
                sessionToken = _yield$this$dependenc.sessionToken;
                this.abortController = new AbortController();
                _context5.next = 7;
                return fetch("".concat(this.config.sessionServiceUrl, "/handle?ticket=").concat(sessionToken), {
                  credentials: 'include',
                  signal: this.abortController.signal
                });

              case 7:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 10;
                  break;
                }

                throw new HTTPError(response);

              case 10:
                return _context5.abrupt("return", true);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function initSession() {
        return _initSession.apply(this, arguments);
      }

      return initSession;
    }()
  }, {
    key: "destroySession",
    value: function () {
      var _destroySession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetch("".concat(this.config.sessionServiceUrl, "/logout"), {
                  credentials: 'include'
                });

              case 2:
                response = _context6.sent;

                if (!(response.status > 400)) {
                  _context6.next = 5;
                  break;
                }

                throw new HTTPError(response);

              case 5:
                return _context6.abrupt("return", true);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function destroySession() {
        return _destroySession.apply(this, arguments);
      }

      return destroySession;
    }()
  }]);

  return SessionService;
}(SessionServiceInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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